export function markdownToSpeech(text) {
  if (!text) return '';
  
  return text
    // Remove code blocks (```...```) entirely as they are hard to listen to
    .replace(/```[\s\S]*?```/g, '')
    // Remove inline code (`code` -> code)
    .replace(/`([^`]+)`/g, '$1')
    // Remove headers (## Header -> Header)
    .replace(/^#{1,6}\s+(.*)/gm, '$1')
    // Remove bold/italic (*text*, **text**, _text_, __text__)
    .replace(/(\*\*|__)(.*?)\1/g, '$2')
    .replace(/(\*|_)(.*?)\1/g, '$2')
    // Remove links ([text](url) -> text)
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    // Remove blockquotes (> text -> text)
    .replace(/^>\s+(.*)/gm, '$1')
    // Remove list markers (- or * or 1.)
    .replace(/^[\s]*[-*+]\s+/gm, '')
    .replace(/^[\s]*\d+\.\s+/gm, '')
    // Cleanup multiple empty lines left behind by code block removal
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
